import { render, staticRenderFns } from "./ApproveMethod.vue?vue&type=template&id=bebb023e&scoped=true"
import script from "./ApproveMethod.vue?vue&type=script&lang=js"
export * from "./ApproveMethod.vue?vue&type=script&lang=js"
import style0 from "./ApproveMethod.vue?vue&type=style&index=0&id=bebb023e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebb023e",
  null
  
)

export default component.exports